module.exports = __webpack_public_path__ + "files/ca270e75a654f76f9093b7287571eb3b.png";